module.exports = __webpack_public_path__ + "img/node-plus.795189f6.svg";